import React, { useContext, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT ------------------------------------------------
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";

// ------------------- COMPONENTES DE BASE -----------------------------------------------------
import { toastShow } from "../../../../../Base/Services/ToastService";
import { confirmDialog } from "primereact/confirmdialog";

import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { getListaCorreos } from "../../../../../Base/API/IT/ListaCorreos/ListaCorreosRequest";


// ------------------- CONSULTAS A LA API -------------------------------------------------------
import {
  postSolicitudEdicionProveedor,
  sendEmailSolicitudEdicionProveedor,
} from "../../../../../API/Compras/Proveedores/ProveedoresRequest";
import { sendEmailInscripcion } from "../../../../../API/Compras/Customers/CustomerRequests";



// ------------------ COMPONENTES DE NECESARIOS ------------------------------------------------

const ModalSolicitudEdicionProveedor = ({
  visible,
  onHide,
  proveedorData,
  IdStatus,
  onSuccess,
  toast,
}) => {

  const [loading, setLoading] = useState(false);
  const { userAuth } = useContext(AuthContext);
  const proveedorActivo = IdStatus === 5;
  const puedeReactivarOHabilitarPago = proveedorData?.IdStatusRevision === 70;

  // Función para obtener la lista de correos
  const SECCIONES = [
    { key: "InformacionEmpresa", label: "Información de empresa" },
    { key: "InformacionContacto", label: "Información de contacto" },
    { key: "InformacionBancaria", label: "Información bancaria" },
    { key: "InformacionComercial", label: "Información comercial" },
    { key: "InformacionFinanciera", label: "Información financiera" },
    { key: "Documentacion", label: "Documentación" },
    { key: "Reactivar", label: "Reactivar proveedor" },
    { key: "HabilitarPago", label: "Habilitar pago" },
  ];
  const ID_LISTA_CORREO_SOLICITUD_EDICION = 10;

  const [values, setValues] = useState({
    InformacionEmpresa: false,
    InformacionContacto: false,
    InformacionBancaria: false,
    InformacionComercial: false,
    InformacionFinanciera: false,
    Documentacion: false,
    Reactivar: false,
    HabilitarPago: false,
    Comentario: "",
  });

  const checkboxes = [
    {
      field: "InformacionEmpresa",
      label: "Información de empresa",
    },
    {
      field: "InformacionContacto",
      label: "Información de contacto",
    },
    {
      field: "InformacionBancaria",
      label: "Información bancaria",
    },
    {
      field: "InformacionComercial",
      label: "Información comercial",
    },
    {
      field: "InformacionFinanciera",
      label: "Información financiera",
    },
    {
      field: "Documentacion",
      label: "Documentación",
    },
  ];

  const limpiarFormulario = () => {
    setValues({
      InformacionEmpresa: false,
      InformacionContacto: false,
      InformacionBancaria: false,
      InformacionComercial: false,
      InformacionFinanciera: false,
      Documentacion: false,
      Reactivar: false,
      HabilitarPago: false,
      Comentario: "",
    });
  };

  const cerrarModal = () => {
    limpiarFormulario();
    onHide();
  };

  const handleCheckboxChange = (field, checked) => {
    if (field === "HabilitarPago") {
      if (checked) {
        setValues((prev) => ({
          ...prev,
          HabilitarPago: true,
          InformacionEmpresa: false,
          InformacionContacto: false,
          InformacionBancaria: false,
          InformacionComercial: false,
          InformacionFinanciera: false,
          Documentacion: false,
          Reactivar: false,
        }));
      } else {
        setValues((prev) => ({
          ...prev,
          HabilitarPago: false,
        }));
      }
  
      return;
    }
  
    setValues((prev) => ({
      ...prev,
      [field]: checked,
      HabilitarPago: false,
    }));
  };

  // Verificar si al menos una opción está seleccionada
  const alMenosUnoSeleccionado = checkboxes.some((item) => values[item.field]) || values.Reactivar ||values.HabilitarPago;

  const enviarCorreoNotificacionSolicitud = async (solicitudCreada) => {
    try {

      const correosTempo = await getListaCorreos();
    //console.log("LISTA DE CORREOS:", correosTempo);
      const correos = correosTempo?.filter((item) => item.IdListaCorreo === ID_LISTA_CORREO_SOLICITUD_EDICION);
  
      if (!correos || correos.length === 0) {
        toastShow(
          toast,
          "warn",
          "Correo",
          "Solicitud guardada, pero no se encontró lista de correos."
        );
        return;
      }
  
      const seccionesMarcadas = SECCIONES.filter(
        (item) => solicitudCreada[item.key]
      );
  
      const listaSecciones =
        seccionesMarcadas.length > 0
          ? `<ul>${seccionesMarcadas
              .map((item) => `<li>${item.label}</li>`)
              .join("")}</ul>`
          : "<p>No se seleccionaron secciones.</p>";
  
      const html = `
        <div>
          <p>Se ha creado una nueva solicitud de edición de proveedor.</p>
  
          <p>
            Correlativo:
            <strong>${solicitudCreada.Correlativo || ""}</strong>
          </p>
  
          <p>
            Proveedor:
            <strong>${proveedorData?.CustomerName || ""}</strong>
          </p>
  
          <p>Secciones solicitadas:</p>
          ${listaSecciones}
  
          <p>
            Comentario:
            ${solicitudCreada.Comentario || "Ninguno"}
          </p>
  
          <br />
  
          <p>*Correo generado automáticamente, por favor no responder.</p>
        </div>
      `;
  
      const objeto = {
        to: correos[0].DestinatariosMail,
        cc: `${correos[0].CCMail || ""},${userAuth?.Email || userAuth?.Mail || ""}`,
        bcc: correos[0].CCoMail,
        subject: "Solicitud de edición de proveedor",
        html,
      };
      //console.log("OBJETO CORREO SOLICITUD EDICION:", objeto);
  
      //const result = await sendEmailInscripcion(objeto, Token);
      const result = await sendEmailSolicitudEdicionProveedor(objeto);
  
      if (!result) {
        toastShow(
          toast,
          "warn",
          "Correo",
          "Solicitud guardada, pero el correo no se pudo enviar."
        );
      }
    } catch (error) {
      console.log("ERROR ENVIANDO CORREO SOLICITUD EDICION:", error);
  
      toastShow(
        toast,
        "warn",
        "Correo",
        "Solicitud guardada, pero ocurrió un error enviando el correo."
      );
    }
  };

 const guardarSolicitud = async () => {
   if (!proveedorData?.IdVendor) {
     toastShow(toast, "error", "Error", "No se encontró el proveedor.");
     return;
   }
 
   if (!alMenosUnoSeleccionado) {
     toastShow(
       toast,
       "warn",
       "Advertencia",
       "Debe seleccionar al menos una opción."
     );
     return;
   }
 
   confirmDialog({
     message: "¿Desea enviar la solicitud de edición?",
     header: "Confirmación",
     icon: "pi pi-exclamation-triangle",
     accept: async () => {
       setLoading(true);
 
       const datos = {
         IdProveedor: proveedorData.IdVendor,
         InformacionEmpresa: values.InformacionEmpresa ? 1 : 0,
         InformacionContacto: values.InformacionContacto ? 1 : 0,
         InformacionBancaria: values.InformacionBancaria ? 1 : 0,
         InformacionComercial: values.InformacionComercial ? 1 : 0,
         InformacionFinanciera: values.InformacionFinanciera ? 1 : 0,
         Documentacion: values.Documentacion ? 1 : 0,
         Reactivar: values.Reactivar ? 1 : 0,
         HabilitarPago: values.HabilitarPago ? 1 : 0,
         Comentario: values.Comentario,
       };
 
       const result = await postSolicitudEdicionProveedor(datos);
 
       const respuesta = Array.isArray(result)
         ? result[0]
         : result?.data?.[0] || result;
 
       if (respuesta?.ERROR === 0) {
         const solicitudCreada = {
           ...datos,
           Correlativo: respuesta?.Correlativo,
         };
 
         await enviarCorreoNotificacionSolicitud(solicitudCreada);
 
         toastShow(
           toast,
           "success",
           "Correcto",
           respuesta?.MSJ || "Solicitud guardada correctamente."
         );
 
         if (onSuccess) {
           await onSuccess();
         }
 
         cerrarModal();
       } else {
         toastShow(
           toast,
           "error",
           "Error",
           respuesta?.MSJ || "No se pudo guardar la solicitud."
         );
       }
 
       setLoading(false);
     },
   });
 };

  const footer = (
    <div className="d-flex justify-content-end gap-2">
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={cerrarModal}
      />

      <Button
        label="Guardar"
        icon="pi pi-save"
        className="p-button-text"
        disabled={!alMenosUnoSeleccionado}
        loading={loading}
        onClick={guardarSolicitud}
      />
    </div>
  );

  return (
    <Dialog
      header="Solicitud de edición de proveedor"
      visible={visible}
      style={{ width: "32rem" }}
      modal
      onHide={cerrarModal}
      footer={footer}
    >
      <div className="d-flex flex-column gap-3">
        {checkboxes.map((item) => (
          <div key={item.field} className="d-flex align-items-center gap-2">
            <Checkbox
              inputId={item.field}
              checked={values[item.field]}
              disabled={!proveedorActivo || values.HabilitarPago}
              onChange={(e) => handleCheckboxChange(item.field, e.checked)}
            />
            
            <label
              htmlFor={item.field}
              style={{
                cursor: !proveedorActivo || values.HabilitarPago ? "not-allowed" : "pointer",
                opacity: !proveedorActivo || values.HabilitarPago ? 0.5 : 1,
              }}
            >
              {item.label}
            </label>
          </div>
        ))}

        <hr style={{ width: "100%" }} />

        <div className="d-flex align-items-center gap-2">
          <Checkbox
            inputId="Reactivar"
            checked={values.Reactivar}
            disabled={proveedorActivo || !puedeReactivarOHabilitarPago}
            onChange={(e) => handleCheckboxChange("Reactivar", e.checked)}
          />
          <label
            htmlFor="Reactivar"
            style={{
              cursor:
                proveedorActivo || !puedeReactivarOHabilitarPago
                  ? "not-allowed"
                  : "pointer",
              opacity:
                proveedorActivo || !puedeReactivarOHabilitarPago
                  ? 0.5
                  : 1,
            }}
          >
            Reactivar proveedor
          </label>
        </div>

        <div className="d-flex flex-column gap-2">
          <label>Comentario</label>
          <InputTextarea
            value={values.Comentario}
            onChange={(e) =>
              setValues((prev) => ({
                ...prev,
                Comentario: e.target.value,
              }))
            }
            rows={5}
            placeholder="Ingrese un comentario..."
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default ModalSolicitudEdicionProveedor;